import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Toolbar,
  Typography,
} from '@mui/material';
import AddFormatButton from 'components/@home/drawers/HrBotDrawer/AddFormatButton';
import { HrBotContext } from 'components/@home/drawers/HrBotDrawer/hrBotContext';
import TemplateListHelp from 'components/@home/drawers/HrBotDrawer/TemplateListHelp';
import sortBy from 'lodash/sortBy';
import DeleteIcon from 'mdi-react/DeleteIcon';
import EditIcon from 'mdi-react/EditIcon';
import SendIcon from 'mdi-react/SendIcon';
import React, { memo, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { I18n } from 'utils/i18n';
import documentFormats from 'store/app/entities/documentFormats/action';

const TemplatesList = () => {
  const { formats, setFormatId, navigateTo } = useContext(HrBotContext);
  const dispatch = useDispatch();
  const formatList = sortBy(Object.values(formats), 'name') || [];

  const sendFormat = id => () => {
    setFormatId(id);
    navigateTo('send');
  };

  const editFormat = id => () => {
    setFormatId(id);
    navigateTo('editTemplate');
  };

  const deleteFormat = id => async () => {
    await dispatch(documentFormats.destroy(id));
    setFormatId(null);
  };

  if (!formatList?.length) {
    return (
      <div>
        <TemplateListHelp isEmpty />
        <AddFormatButton onClick={editFormat()} />
      </div>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        maxHeight: '100%',
        overflow: 'scroll',
      }}
    >
      <TemplateListHelp onAddFormat={editFormat()} />
      <Box sx={{ flexGrow: 1, maxHeight: '100%', mt: 2 }}>
        <Toolbar
          sx={{
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={theme => ({
              display: 'flex',
              alignItem: 'center',
              color: theme.palette.text.secondary,
            })}
          >
            <AddFormatButton onClick={editFormat()} />
          </Box>
        </Toolbar>
        <Table sx={{ maxHeight: '100%' }}>
          <TableHead
            sx={theme => ({
              width: '100%',
              borderTop: `1px solid ${theme.palette.divider}`,
            })}
          >
            <TableRow sx={{ height: 40 }}>
              <TableCell name="name" padding="none">
                <Typography
                  sx={theme => ({
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: 1.29,
                    color: theme.palette.secondary.main,
                  })}
                >
                  {I18n.t('HrBot.Name')}
                </Typography>
              </TableCell>
              <TableCell name="actions" align="right">
                <Typography
                  sx={theme => ({
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: 1.29,
                    color: theme.palette.secondary.main,
                  })}
                >
                  {I18n.t('HrBot.Actions')}
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {formatList.map(format => {
              return (
                <TableRow sx={{ height: 40 }} key={format.name}>
                  <TableCell padding="none">{format.name}</TableCell>
                  <TableCell align="right">
                    <IconButton onClick={sendFormat(format._id)} size="large">
                      <SendIcon />
                    </IconButton>
                    <IconButton onClick={editFormat(format._id)} size="large">
                      <EditIcon />
                    </IconButton>
                    <IconButton onClick={deleteFormat(format._id)} size="large">
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

export default memo(TemplatesList);
